import React, {Component} from 'react';
import {Modal, Button, Icon} from 'semantic-ui-react';
import BarChart from '../chart/bar';
import LineChart from '../chart/line';
import PieChart from '../chart/pie';

class ChartSectionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
    };
    this.openModal = this.openModal.bind(this);
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
  }

  openModal() {
    this.setState({
      'modalWasOpen': true,
    });
  }

  onCloseModalClick() {
    this.setState({'modalWasOpen': false});
  }

  renderChart() {
    const {data, typeOfGraphicSelected, handleDrillDownByUser} = this.props;
    if (!data || !data.length) {
      return (
        <div className='empty-chart'>No hay datos para generar el gráfico</div>
      );
    }
    switch (typeOfGraphicSelected) {
      default:
      case 'bar':
        return (
          <BarChart data={data} handleDrillDownByUser={handleDrillDownByUser} />
        );
      case 'line':
        return (
          <LineChart
            data={data}
            handleDrillDownByUser={handleDrillDownByUser}
          />
        );
      case 'pie':
        return (
          <PieChart data={data} handleDrillDownByUser={handleDrillDownByUser} />
        );
    }
  }

  render() {
    const {data, lineLabel} = this.props;
    const {modalWasOpen} = this.state;

    if (!data || !data.length) {
      return null;
    }
    return (
      <Modal
        size='fullscreen'
        onOpen={this.openModal}
        open={modalWasOpen}
        className='reprinter-picking-labels'
        trigger={<Icon link name='expand' color='black' size='big' />}
      >
        <Modal.Header>Gráfico de líneas {lineLabel}</Modal.Header>

        <Modal.Content>
          <Modal.Description>{this.renderChart()}</Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={this.onCloseModalClick}>Cerrar</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default ChartSectionModal;
